import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { UserModel } from '@app/modules/user/model/user';
import { UserState } from '@app/modules/user/store/user.state';

interface PortalNavItem {
  label: string;
  icon: string;
  link: string;
  /** Extra prefixes that should also light this item up (e.g. redirects). */
  activePrefixes?: string[];
  exact?: boolean;
}

/**
 * Persistent left navigation for PATIENT users across /office. Doctors,
 * admins and proxies never see it (template renders nothing for them), so
 * their existing navigation is untouched. Collapses to a horizontal strip on
 * small screens.
 */
@Component({
  selector: 'app-patient-sidebar',
  templateUrl: './patient-sidebar.component.html',
  styleUrls: ['./patient-sidebar.component.sass'],
})
export class PatientSidebarComponent {
  @Select(UserState.model) public user$: Observable<UserModel>;

  public readonly items: PortalNavItem[] = [
    { label: 'My Dashboard', icon: 'pi-home', link: '/office/portal', exact: true },
    {
      label: 'My Advance Care Plan',
      icon: 'pi-compass',
      link: '/office/acp',
      activePrefixes: ['/office/acp', '/office/portal/acp'],
    },
    {
      label: 'My Care Team & Agents',
      icon: 'pi-users',
      link: '/office/portal/care-team',
      activePrefixes: ['/office/portal/care-team', '/office/consent', '/epic/requests'],
    },
    {
      label: 'My Documents',
      icon: 'pi-file',
      link: '/office/portal/documents',
      activePrefixes: ['/office/portal/documents', '/office/living-will'],
    },
    {
      label: 'My Emergency Card',
      icon: 'pi-id-card',
      link: '/office/dashboard/share',
      activePrefixes: ['/office/dashboard/share', '/office/portal/emergency-info'],
    },
    { label: 'Help', icon: 'pi-question-circle', link: '/office/portal/help', activePrefixes: ['/office/portal/help'] },
  ];

  constructor(private readonly router: Router) {}

  public isActive(item: PortalNavItem): boolean {
    const url = this.router.url.split('?')[0];
    if (item.exact) {
      return url === item.link;
    }
    return (item.activePrefixes || [item.link]).some((prefix) => url === prefix || url.startsWith(`${prefix}/`));
  }
}
